import { createContext } from "react";

interface LayoutContextProps {
  activeView: string;
  setActiveView: (view: string) => void;
  menuOpen: boolean;
  setMenuOpen: (value: boolean) => void;
  menuLocked: boolean;
  setMenuLocked: (value: boolean) => void;
  subMenuOpen: boolean;
  setSubMenuOpen: (value: boolean) => void;
}

const LayoutContext = createContext<LayoutContextProps>({
  activeView: "contactInfo",
  setActiveView: () => {},
  menuOpen: true,
  setMenuOpen: () => {},
  menuLocked: true,
  setMenuLocked: () => {},
  subMenuOpen: false,
  setSubMenuOpen: () => {},
});

export default LayoutContext;
